import Content from "components/Content";
import Label from "components/Label";
import AnimatedGrowth from "pages/homepage/components/WeAreGrowing/components/AnimatedGrowth";
import React, { FC } from "react";

import HomeOutline from "../../../../../public/home-outline.svg";

import styles from "./styles.module.scss";

const NeonHomeCounter: FC = () => {
  return (
    <Content
      disableMotion
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label variant="h-centered" className={styles.title} color="white">
        We’re Growing Fast
      </Label>
      <div className={styles.info}>
        <HomeOutline className={styles.homeSVG} />
        <AnimatedGrowth
          titleClassName={styles.infoTitle}
          subtitleClassName={styles.infoSubtitle}
          animated
          value={500}
          title="Homes (and counting!)"
          withPostfix
        />
      </div>
    </Content>
  );
};

export default NeonHomeCounter;
